<template>
  <AuthenticatedLayout>
    <CategoriasApiTable />
  </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from "@/components/AuthenticatedLayout.vue";
import CategoriasApiTable from "@/views/components/CategoriasApiTable.vue";

export default {
  name: "CategoriasApi",
  components: {
    AuthenticatedLayout,
    CategoriasApiTable,
  },
};
</script>

